// extracted by mini-css-extract-plugin
export var bp = "'../../theme/breakpoints.module.css'";
export var xmedium = "640px";
export var small = "480px";
export var xsmall = "320px";
export var palette = "'../../theme/palette.module.css'";
export var accent = "#3D5CFF";
export var wrapper = "style-module--wrapper--2KV-f";
export var bubble = "style-module--bubble--2Vcy7";
export var logo = "style-module--logo--z7lnu";